import { getPanelBodyMarineList } from 'components/weather-warning/panel-body-marine-list-container.js';
import { IWarning } from 'redux-state/weather-warnings/types.js';
import { PanelBodyMarineList } from 'utilities/weather-warnings/panel-body-marine-list.js';

export interface IWarningProps {
  noDataMessage: string;
  warnings: IWarning[];
  content?: string;
}

export const MarineWarningsPresentation = ({ noDataMessage, warnings, content }: IWarningProps) => {
  if (!warnings.length) {
    return <p>{noDataMessage}</p>;
  }

  const warnArr = getPanelBodyMarineList({ warnings });
  return (
    <div data-module="marine-warnings-presentation">
      {content}
      {warnArr.map((wa) => (
        <div key={wa.key} className="ArticleList-item">
          <PanelBodyMarineList warnings={wa.warnArr} />
        </div>
      ))}
    </div>
  );
};
